import { Component, OnInit, ViewChild, ViewEncapsulation, Input } from "@angular/core";
import { NavbarComponent } from "./navbar/navbar.component";

@Component({
    selector: "app-header",
    templateUrl: "./header.component.html",
    styleUrls: ["./header.component.scss"],
    encapsulation: ViewEncapsulation.None,
    imports: [NavbarComponent]
})
export class HeaderComponent implements OnInit {
  constructor() {}

  async ngOnInit() {}
}
